
import React, { useState, useEffect, useContext } from "react";

import { AppThemeContext } from "../../../../../../../../context/AppThemeContext";
import { useTheme } from "@emotion/react";
import AppModal from "../../../../../../../../components/AppModal";
import InvverterFullSize from "../../../../../../../../components/inverter/InvverterFullSize";
import PlantEnergyKusumData from "./PlantEnergyKusumData";


// Utility function to format date as 'YYYY-MM-DD HH:mm'
const formatDateTime = (date) => {
    const pad = (num) => String(num).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export default function PlantEnergyKusum() {
    const { PrimaryColor } = useContext(AppThemeContext);
    const { palette } = useTheme();
    const [OpenMix, setOpenMix] = useState(false);
    const handleOpenMix = () => setOpenMix(true);
    const handleCloseMix = () => setOpenMix(false);

    const now = new Date(); // Current date and time

    // Default start and end dates
    const initialStartDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 5, 0); // 5:00 AM
    const initialEndDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 20, 0); // 8:00 PM

    const [startDate, setStartDate] = useState(formatDateTime(initialStartDate));
    const [endDate, setEndDate] = useState(formatDateTime(initialEndDate));
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

   
    return (

        <>
            <div className="row">

                <div className="col-md-12">

                    

                    {loading && <p>Loading chart data...</p>}
                    {error && <p style={{ color: "red" }}>{error}</p>}
                    {!loading && !error && (
                        <>
                            <InvverterFullSize title={``} onFullScreen={handleOpenMix} />
                           <PlantEnergyKusumData/>
                            <AppModal open={OpenMix} handleClose={handleCloseMix}>
                             <PlantEnergyKusumData/>
                            </AppModal>
                        </>
                    )}
                </div>
            </div>


        </>


    );
}






